export default [
	{
		path: '/assistant',
		name: 'assistant',
		component: () => import(/* assistant*/ './index.vue'),
		meta: {
			title: '',
			// keepAlive: true  //是否设置为缓存数据页面
		},
		children: [
			{
				path: 'web/index',
				name: 'assistant_web_index',
				component: () => import(/* assistant_web_index*/ './pages/index.vue'),
				meta: {
					title: '',
					auth: true, // 如果此路由需要微信授权请设置为true,默认为false
					// keepAlive: true  //是否设置为缓存数据页面
				}
			},
			{
				path: 'web/step2',
				name: 'activity_web_step2',
				component: () => import(/* activity_web_step2*/ './pages/step2.vue'),
				meta: {
					title: '',
					auth: false, // 如果此路由需要微信授权请设置为true,默认为false
					// keepAlive: true  //是否设置为缓存数据页面
				},
			}
		]
	}
]
